import { neighborhoodKey } from '@aquabox/shared';
import { paletteColorForOrder } from './street-map';
import type { Order, Region } from '../api/types';

/** Panel `Order` tipinde lat/lng yok; sipariş listesi yanıtı taşır (orders.service ORDER_INCLUDE). */
export function orderPoint(o: Order): [number, number] | null {
  const { lat, lng } = o as Order & { lat?: number | null; lng?: number | null };
  if (typeof lat !== 'number' || typeof lng !== 'number') return null;
  if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
  return [lat, lng];
}

type Ring = number[][];
type Polygon = Ring[];

export interface HoodFeature {
  properties?: { name?: string } | null;
  geometry?: { type: string; coordinates: unknown } | null;
}

export interface RegionShape {
  type: 'Feature';
  properties: { regionId: string; name: string; color: string };
  geometry: { type: 'MultiPolygon'; coordinates: Polygon[] };
}

/**
 * Her bölgenin mahalle poligonlarını TEK MultiPolygon özelliğinde toplar (bölge başına bir
 * katman, bir tooltip). Mahalle adı eşleşmesi paylaşılan `neighborhoodKey` ile (Türkçe katlama + Mah/Mahallesi eki; API ile AYNI).
 * Bir mahalle birden çok bölgede geçiyorsa API `regionForNeighborhood` null döner; harita da o
 * mahalleyi HİÇBİR bölgeye çizmez (belirsiz).
 * Poligonu olmayan bölge çizilmez.
 */
export function buildRegionShapes(
  hoods: readonly HoodFeature[],
  regions: readonly Region[],
): RegionShape[] {
  const byHood = new Map<string, Polygon[]>();
  for (const f of hoods) {
    const name = f.properties?.name;
    const g = f.geometry;
    if (!name || !g) continue;
    const polys =
      g.type === 'Polygon'
        ? [g.coordinates as Polygon]
        : g.type === 'MultiPolygon'
          ? (g.coordinates as Polygon[])
          : [];
    if (polys.length === 0) continue;
    const k = neighborhoodKey(name);
    byHood.set(k, [...(byHood.get(k) ?? []), ...polys]);
  }
  const owners = new Map<string, Set<string>>();
  for (const r of regions) {
    for (const n of r.neighborhoods) {
      const k = neighborhoodKey(n);
      owners.set(k, (owners.get(k) ?? new Set()).add(r.id));
    }
  }
  const out: RegionShape[] = [];
  regions.forEach((r, i) => {
    const coordinates = [...new Set(r.neighborhoods.map(neighborhoodKey))]
      .filter((k) => owners.get(k)?.size === 1)
      .flatMap((k) => byHood.get(k) ?? []);
    if (coordinates.length === 0) return;
    out.push({
      type: 'Feature',
      properties: { regionId: r.id, name: r.name, color: r.color ?? paletteColorForOrder(i) },
      geometry: { type: 'MultiPolygon', coordinates },
    });
  });
  return out;
}

/** DayBoard ile aynı sorgu parametreleri (paylaşılan önbellek). */
export const PENDING_ORDER_STATUSES = 'NEW,CONFIRMED';
export const ASSIGNED_ORDER_STATUSES = 'ASSIGNED,ON_ROUTE';
